import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { formatUpdated } from '../../lib/wiki/wikiData';

const statusStyles = {
  stable: { key: 'stable', className: 'bg-green-50 text-green-800' },
  draft: { key: 'draft', className: 'bg-amber-50 text-amber-800' },
  deprecated: { key: 'deprecated', className: 'bg-gray-100 text-gray-600' },
};

export function PageMetadataBar({
  title,
  summary,
  updated,
  owner,
  reviewBy,
  status = 'stable',
  localeFallback = false,
}) {
  const { language, t } = useLanguage();
  const statusBadge = statusStyles[status] || statusStyles.stable;

  return (
    <header className="border-b border-gray-200 pb-4 mb-6">
      {localeFallback && (
        <p className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900">
          {t('wiki.fallbackBanner')}
        </p>
      )}
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">{title}</h1>
      {summary && (
        <p className="text-base text-gray-600 mb-3 leading-relaxed">{summary}</p>
      )}
      <div className="flex flex-wrap items-center gap-2 text-sm text-gray-500">
        <span>
          {t('wiki.lastUpdated')} {formatUpdated(updated, language)}
        </span>
        {reviewBy && (
          <span>
            · {t('wiki.reviewBy')} {formatUpdated(reviewBy, language)}
          </span>
        )}
        {owner && (
          <span
            className="inline-flex items-center rounded-full bg-blue-50 px-2.5 py-0.5 text-blue-700"
            title={t('wiki.ownerTitle')}
          >
            {owner}
          </span>
        )}
        <span
          className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${statusBadge.className}`}
        >
          {t(`wiki.status.${statusBadge.key}`)}
        </span>
        <span className="rounded bg-gray-100 px-2 py-0.5 text-xs text-gray-600">
          {t('wiki.readOnly')}
        </span>
      </div>
    </header>
  );
}
